import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import I18n from '../../../../common/components/i18n/i18n';
import { setChatDocUID } from '../utils/chatdoc-uid';

const Layout = ({ children, className }) => {
  useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          isTestEnv
          isDevEnv
        }
      }
    }
  `);

  useEffect(() => {
    setChatDocUID();
  }, []);

  return (
    <I18n>
      <div className={className}>{children}</div>
    </I18n>
  );
};

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  className: PropTypes.string,
};

export default Layout;
